import type { CalibrationKind } from '../../types';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = (): {
    CALIBRATION_KIND_LABELS: Record<CalibrationKind, string>;
    NO_CALIBRATION_KINDS_FOUND: string;
    SEARCH: string;
} => {
    const t = useTranslate('calibrationKindSelectPanelField');

    return {
        CALIBRATION_KIND_LABELS: {
            FLOW: t('flow'),
            LEVEL: t('level'),
            MAGNETOMETER: t('magnetometer'),
            PUMP: t('pump'),
            WEIGHT: t('weight')
        },
        NO_CALIBRATION_KINDS_FOUND: t('noCalibrationKindsFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
